import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { StripeConfigurationFooter } from './components/StripeConfigurationFooter';
import { StripeConfigurationForm } from './components/StripeConfigurationForm';
import type { StripeConfigurationFormValues } from './StripeConfigurationFormSchema';
import { StripeConfigurationFormSchema } from './StripeConfigurationFormSchema';

export const ConfigureStripeComponents: FormDrawerProps<ZodSchema<StripeConfigurationFormValues>> = {
  zodSchema: StripeConfigurationFormSchema,
  ContentComponent: StripeConfigurationForm,
  Footer: StripeConfigurationFooter,
};
